import type z from 'zod/v4'
import { relations } from 'drizzle-orm'
import { index, pgTable, primaryKey, text, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema, createUpdateSchema } from 'drizzle-zod'

import { organization } from '../../../auth'
import { Challenge } from './challenge'

/**
 * Challenge to School Organization relationship table
 * Stores school organization runtimeIds for challenges that are not public
 */
export const ChallengeToOrganization = pgTable(
  'challenge_to_organization',
  {
    challengeId: uuid()
      .notNull()
      .references(() => Challenge.id, { onDelete: 'cascade' }),
    organizationId: text()
      .notNull()
      .references(() => organization.id, { onDelete: 'cascade' }),
  },
  (table) => [
    primaryKey({ columns: [table.challengeId, table.organizationId] }),
    index('challenge_to_organization_challenge_idx').on(table.challengeId),
    index('challenge_to_organization_organization_id_idx').on(table.organizationId),
  ],
)

export const challengeToOrganizationRelations = relations(ChallengeToOrganization, ({ one }) => ({
  challenge: one(Challenge, {
    fields: [ChallengeToOrganization.challengeId],
    references: [Challenge.id],
  }),

  organization: one(organization, {
    fields: [ChallengeToOrganization.organizationId],
    references: [organization.id],
  }),
}))

export const InsertChallengeToOrganizationSchema = createInsertSchema(ChallengeToOrganization)
export const UpdateChallengeToOrganizationSchema = createUpdateSchema(ChallengeToOrganization).partial()
export const SelectChallengeToOrganizationSchema = createSelectSchema(ChallengeToOrganization)

export type InsertChallengeToOrganization = typeof ChallengeToOrganization.$inferInsert
export type UpdateChallengeToOrganization = z.infer<typeof UpdateChallengeToOrganizationSchema>
export type SelectChallengeToOrganization = typeof ChallengeToOrganization.$inferSelect
